import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { IconButton, InputAdornment } from '@mui/material';
import {
  ErrorHelperTextStyle,
  RHFTextFieldProps,
} from '@/components/HookForm/RHFTextField';
import { useState } from 'react';
import EyeShowIcon from '@/public/icons/eye_show.svg';
import EyeHideIcon from '@/public/icons/eye_hide.svg';

export default function RHFPasswordField({
  name,
  helperText,
  size,
  sx,
  onClear,
  ...other
}: Omit<RHFTextFieldProps, 'type' | 'maxLength'>) {
  const [showPassword, setShowPassword] = useState(false);

  const { control, clearErrors } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={(e) => {
            const value = e.target.value.replace(/\s/g, '');
            field.onChange(value);
          }}
          fullWidth
          type={showPassword ? 'text' : 'password'}
          value={field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  {field.value && (
                    <IconButton
                      onClick={() => {
                        field.onChange('');
                        clearErrors(name);
                        onClear?.();
                      }}
                    >
                      <img
                        src={'/icons/close_gray.svg'}
                        width={16}
                        height={16}
                        alt={'close icon'}
                      />
                    </IconButton>
                  )}
                  <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                    {showPassword ? <EyeShowIcon /> : <EyeHideIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            },
            formHelperText: {
              sx: {
                ...ErrorHelperTextStyle,
                color: error
                  ? 'var(--dk-danger, #F55060)'
                  : 'var(--dk-text-secondary, #888D96)',
              },
            },
          }}
          sx={{
            '& .MuiInputBase-input::placeholder': {
              fontSize: '14px',
            },
            '& .MuiInputBase-root': {
              height: '48px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: '1px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--dk-text, #000)',
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: '1px',
              borderColor: 'var(--dk-text, #000)',
            },
            ...sx,
          }}
          {...other}
        />
      )}
    />
  );
}
